export default __webpack_public_path__ + "static/assets/images/explore-footer-background.97dcb880e51a2a363a7ee1f43a2bee00.svg";